import React, { useEffect, useState } from "react";
import superMenuItems from "Constants/superMenuItems";
import { read } from "Helpers/LocalStorage";
import { ReactSVG } from "react-svg";
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@material-ui/core";
import { Scrollbars } from "react-custom-scrollbars";
import Translator from "Languages/Utility/Translator";
import { NavLink } from "react-router-dom";
import { SET_MENU_DRAWER } from "Stores/actionTypes";
import { useDispatch, useSelector } from "react-redux";

export default function SideDrawer() {
  const dispatch = useDispatch();
  let StypeUA = read("StypeUA");
  let _menuList = [...superMenuItems.Category];
  const { menuStatus } = useSelector((state) => ({
    menuStatus: state.auth.menuStatus,
  }));
  const [menuItems, setMenuItems] = useState(null);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [sizeChange, setSizeChange] = useState(true);

  useEffect(() => {
    setSizeChange(window.innerWidth > 576 ? true : false);
    window.onresize = () => {
      setSizeChange(window.innerWidth > 576 ? true : false);
    };
  }, []);

  useEffect(() => {
    setOpenDrawer(menuStatus);
  }, [menuStatus]);

  useEffect(() => {
    let acs_menuList = _menuList.map((item) => {
      if (item.menu_title === "sami_pricing") {
        item.authorize = !!read("FormPriceSuperAdmin");
      }
      if (item.menu_title === "sami_support") {
        item.authorize = !!read("Support");
      }
      if (item.menu_title === "sami_tickets") {
        item.authorize = !!read("FormCustomerSupport");
      }
      if (item.menu_title === "sami_notices") {
        item.authorize = !!read("Notice");
      }
      if (item.menu_title === "sami_financial") {
        item.authorize = !!read("Financial");
      }
      if (item.menu_title === "sami_tools") {
        item.authorize =
          !!read("FormDiscount") ||
          !!read("FormIncTime") ||
          !!read("FormManualCredit");
      }
      if (item.menu_title === "sami_statistics") {
        item.authorize = !!read("Statistics");
      }
      return item;
    });
    const menuList = acs_menuList
      .filter((item) => item.userAccess.includes(StypeUA))
      .filter((item) => item.authorize)
      .map((menu) => {
        return (
          <NavLink
            key={`NL-${menu.menu_title}`}
            activeClassName="itemActive"
            to={menu.path}
          >
            <ListItem className="listItem mb-2">
              <ListItemIcon>
                <i className="drawerIcon material-icons">
                  <ReactSVG src={menu.menu_icon} />
                </i>
              </ListItemIcon>
              <ListItemText
                className="drawerText"
                primary={<Translator id={menu.menu_title} />}
              />
            </ListItem>
          </NavLink>
        );
      });
    setMenuItems(menuList);
  }, []);

  const onCloseDrawer = () => {
    setOpenDrawer(false);
    dispatch({ type: SET_MENU_DRAWER, status: false });
  };

  return (
    <Drawer
      variant={`${sizeChange ? "permanent" : ""}`}
      classes={{ paper: "drawerOpen" }}
      open={sizeChange ? true : openDrawer}
      onMouseDown={onCloseDrawer}
    >
      <div className="logoSection super-admin">
        <strong className="text-nowrap mt-2">
          <i>
            <u>SuperAdmin</u>
          </i>
        </strong>
      </div>
      <Scrollbars
        className="rct-scroll"
        autoHide
        autoHideDuration={100}
        style={{
          height: "calc(100vh - 40px)",
          direction: "ltr",
          overflowX: "hidden",
          marginTop: "20px",
        }}
      >
        <List className="list">{menuItems}</List>
      </Scrollbars>
    </Drawer>
  );
}
